var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLargeDots = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 374,
  height: 372,
  fill: "none",
  viewBox: "0 0 374 372"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 32.595,
  cy: 339.742,
  r: 31.606,
  fill: "#9CD3FF",
  fillOpacity: 0.2,
  opacity: 0.3,
  transform: "rotate(-180 32.595 339.742)"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 32.595,
  cy: 186.226,
  r: 31.606,
  fill: "#9CD3FF",
  fillOpacity: 0.2,
  opacity: 0.3,
  transform: "rotate(-180 32.595 186.226)"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 32.595,
  cy: 109.468,
  r: 31.606,
  fill: "#9CD3FF",
  fillOpacity: 0.4,
  opacity: 0.3,
  transform: "rotate(-180 32.595 109.468)"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 32.595,
  cy: 32.71,
  r: 31.606,
  fill: "#9CD3FF",
  fillOpacity: 0.4,
  opacity: 0.2,
  transform: "rotate(-180 32.595 32.71)"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 109.916,
  cy: 339.742,
  r: 31.606,
  fill: "#9CD3FF",
  fillOpacity: 0.2,
  opacity: 0.5,
  transform: "rotate(-180 109.916 339.742)"
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  cx: 109.916,
  cy: 262.984,
  r: 31.606,
  fill: "#9CD3FF",
  fillOpacity: 0.2,
  opacity: 0.6,
  transform: "rotate(-180 109.916 262.984)"
})), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
  cx: 109.916,
  cy: 109.468,
  r: 31.606,
  fill: "#9CD3FF",
  fillOpacity: 0.4,
  opacity: 0.2,
  transform: "rotate(-180 109.916 109.468)"
})), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
  cx: 109.916,
  cy: 32.71,
  r: 31.606,
  fill: "#9CD3FF",
  fillOpacity: 0.4,
  opacity: 0.1,
  transform: "rotate(-180 109.916 32.71)"
})), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
  cx: 187.239,
  cy: 339.742,
  r: 31.606,
  fill: "#9CD3FF",
  fillOpacity: 0.2,
  opacity: 0.3,
  transform: "rotate(-180 187.239 339.742)"
})), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
  cx: 187.239,
  cy: 262.984,
  r: 31.606,
  fill: "#9CD3FF",
  fillOpacity: 0.2,
  opacity: 0.5,
  transform: "rotate(-180 187.239 262.984)"
})), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
  cx: 187.239,
  cy: 186.226,
  r: 31.606,
  fill: "#9CD3FF",
  fillOpacity: 0.2,
  opacity: 0.2,
  transform: "rotate(-180 187.239 186.226)"
})), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
  cx: 187.239,
  cy: 109.468,
  r: 31.606,
  fill: "#9CD3FF",
  fillOpacity: 0.4,
  opacity: 0.5,
  transform: "rotate(-180 187.239 109.468)"
})), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
  cx: 187.239,
  cy: 32.71,
  r: 31.606,
  fill: "#9CD3FF",
  fillOpacity: 0.4,
  opacity: 0.2,
  transform: "rotate(-180 187.239 32.71)"
})), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
  cx: 264.561,
  cy: 262.984,
  r: 31.606,
  fill: "#9CD3FF",
  fillOpacity: 0.2,
  opacity: 0.25,
  transform: "rotate(-180 264.561 262.984)"
})), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
  cx: 264.561,
  cy: 186.226,
  r: 31.606,
  fill: "#9CD3FF",
  fillOpacity: 0.2,
  opacity: 0.35,
  transform: "rotate(-180 264.561 186.226)"
})), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
  cx: 264.561,
  cy: 32.71,
  r: 31.606,
  fill: "#9CD3FF",
  fillOpacity: 0.4,
  opacity: 0.1,
  transform: "rotate(-180 264.561 32.71)"
})), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
  cx: 341.884,
  cy: 339.742,
  r: 31.606,
  fill: "#9CD3FF",
  fillOpacity: 0.4,
  opacity: 0.2,
  transform: "rotate(-180 341.884 339.742)"
})), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
  cx: 341.884,
  cy: 262.984,
  r: 31.606,
  fill: "#9CD3FF",
  fillOpacity: 0.4,
  opacity: 0.3,
  transform: "rotate(-180 341.884 262.984)"
})), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
  cx: 341.884,
  cy: 186.226,
  r: 31.606,
  fill: "#9CD3FF",
  fillOpacity: 0.4,
  opacity: 0.1,
  transform: "rotate(-180 341.884 186.226)"
})), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
  cx: 341.884,
  cy: 109.468,
  r: 31.606,
  fill: "#9CD3FF",
  fillOpacity: 0.4,
  opacity: 0.2,
  transform: "rotate(-180 341.884 109.468)"
})), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
  cx: 341.884,
  cy: 32.808,
  r: 31.606,
  fill: "#9CD3FF",
  fillOpacity: 0.4,
  opacity: 0.5,
  transform: "rotate(-180 341.884 32.808)"
})), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
  cx: 32.595,
  cy: 262.984,
  r: 31.606,
  fill: "#9CD3FF",
  fillOpacity: 0.4,
  transform: "rotate(-180 32.595 262.984)"
})), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
  cx: 109.917,
  cy: 186.146,
  r: 31.606,
  fill: "#9CD3FF",
  fillOpacity: 0.2,
  transform: "rotate(-180 109.917 186.146)"
})), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
  cx: 264.561,
  cy: 339.743,
  r: 31.606,
  fill: "#9CD3FF",
  fillOpacity: 0.4,
  transform: "rotate(-180 264.561 339.743)"
})), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
  cx: 264.561,
  cy: 109.468,
  r: 31.606,
  fill: "#9CD3FF",
  fillOpacity: 0.2,
  transform: "rotate(-180 264.561 109.468)"
})));
export { SvgLargeDots as ReactComponent };
export default "data:image/svg+xml;base64,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";